// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@babel/polyfill'
import 'element-ui/lib/theme-chalk/index.css';
import { Breadcrumb, BreadcrumbItem, Pagination, Tabs, TabPane, Icon, Steps, Step, Message, MessageBox, Alert, Dialog, Cascader, CascaderPanel, Timeline, TimelineItem, Button, ButtonGroup, Input, Table, TableColumn, DatePicker, Checkbox, CheckboxGroup, Select, Option, Tooltip, Form, FormItem, Col, Row, Radio, RadioGroup, Upload, Popover } from 'element-ui';
import dpmshttp from '@/plugins/dpmsHttp.js'
import http from '@/plugins/http.js'
import erphttp from '@/plugins/erphttp.js'
import md5 from 'js-md5'
import 'fullpage.js/vendors/scrolloverflow'
import VueFullPage from 'vue-fullpage.js/dist/vue-fullpage.js'
import "../static/css/fullpage.min.css";
import animated from 'animate.css'
// import BaiduMap from 'vue-baidu-map'


Vue.prototype.$md5 = md5;

Vue.config.productionTip = false
Vue.use(http);
Vue.use(dpmshttp);
Vue.use(erphttp);
Vue.use(VueFullPage);
Vue.use(animated);
// Vue.use(BaiduMap, {
//     ak : 'tzYvhtBGdi5kNhFFRtIps1KOxZ4jM1hF'
// })

Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Icon)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Alert)
Vue.use(Dialog)
Vue.use(Cascader)
Vue.use(CascaderPanel)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Col)
Vue.use(Row)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Upload)
Vue.use(Popover)
Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;


/* eslint-disable no-new */
new Vue({ 
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js